import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=2745d9ce&scoped=true&"
import script from "./Credits.vue?vue&type=script&lang=ts&"
export * from "./Credits.vue?vue&type=script&lang=ts&"
import style0 from "./Credits.vue?vue&type=style&index=0&id=2745d9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745d9ce",
  null
  
)

export default component.exports